import { Component } from '@angular/core';
import { ByocUploadContentService } from './../../service/upload-content.service';
import { ByocEpisodeService } from './../../service/episode.service';
import { control } from '../../../utils';

@Component({
    selector: 'app-byoc-episode-step-upload-video',
    templateUrl: './upload-video.component.html',
    styleUrls: ['./upload-video.component.scss'],
    standalone: false
})
export class ByocEpisodeStepUploadVideoComponent {
    constructor(
        private byocEpisodeService: ByocEpisodeService,
        private uploadContentService: ByocUploadContentService,
    ) {}

    get termsAcceptControl() {
        return control(this.byocEpisodeService.form.get('hostedCustomContent')!.get('termsAccept'));
    }

    get videoControl() {
        return this.uploadContentService.fileControl;
    }

    get hasFile() {
        return this.videoControl.value?.file !== null;
    }

    get hasAcceptTerms() {
        return this.termsAcceptControl.value;
    }

    next() {
        if (this.hasAcceptTerms) {
            this.uploadContentService.uploadVideoGoToGeneralStepFrom();
        }
    }

    cancel() {
        this.byocEpisodeService.close('btn-close');
    }
}
